module.exports = "/assets/21746ae5b7c5787fe0be7d16f9a38645.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FS.png
// module id = 2506
// module chunks = 0